import { useMemo } from 'react'
import { useDemoResources } from './useDemoResources'
import { useSchoolGroups } from './useSchoolGroups'

const useSchoolGroupsOptions = () => {
  const { schoolGroups, isLoading, error } = useSchoolGroups()
  const {
    demoSchoolGroups,
    isLoading: isLoadingDemo,
    error: demoError,
  } = useDemoResources()

  return {
    schoolGroupsOptions: useMemo(() => {
      if (!Array.isArray(demoSchoolGroups) || !Array.isArray(schoolGroups)) {
        return []
      }
      return [
        ...demoSchoolGroups.map((schoolGroup) => ({
          value: `/demogrupp/${schoolGroup.id}`,
          name: schoolGroup.name,
        })),
        ...schoolGroups.map((schoolGroup) => ({
          value: `/grupp/${schoolGroup.id}`,
          name: schoolGroup.name,
        })),
      ]
    }, [schoolGroups, demoSchoolGroups]),
    error: error || demoError,
    isLoading: !error && !demoError && !(isLoading || isLoadingDemo),
  }
}

export { useSchoolGroupsOptions }
